/**
 * 類似日ダイアログの初期 Selected を決定する hook。
 *
 * 優先度:
 *   1. existingHeaderDates が 1 件以上 → それを初期 Selected として引き継ぐ
 *   2. existingHeaderDates が 0 件 → autoSelected を使用 (undefined/空の場合は [])
 *
 * backend が auto_selected 無し (対象日予想気温 null/空 等) を返した場合は
 * autoSelected=undefined が渡され、エラーを出さずに selected=[] を返す。
 */
import { useMemo } from 'react'

import { resolveInitialSelected } from '~/pages/DemandForecastDaily/models/similarDayDialog'

type Params = {
  /** backend が返す自動選択日付群。undefined は自動選択不可を意味する */
  autoSelected: string[] | undefined
  /** 過去実績列ヘッダーに既にセット済みの日付群 */
  existingHeaderDates: string[]
}

type Result = {
  /** 初期 Selected として使用する日付群 */
  selected: string[]
}

export function useSimilarDayInitialSelected({
  autoSelected,
  existingHeaderDates,
}: Params): Result {
  const selected = useMemo(() => {
    const safeAutoSelected = autoSelected ?? []
    return resolveInitialSelected(existingHeaderDates, safeAutoSelected)
  }, [autoSelected, existingHeaderDates])

  return { selected }
}
